import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addPage({ dispatch, commit }, page) {
    try {
      const { data } = await request.post('pages', page);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
